module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy2",
    attrs: {
      "id": "copyright"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("This publication received generous support from the Stephen M. Silberstein Foundation.")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Poem “My Teacher” © Alice Walker, excerpted with permission of Alice Walker.")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("© 2018 by the University of Georgia Press"), _c('br'), _vm._v("Athens, Georgia 30602"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.ugapress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ugapress.org")]), _c('br'), _vm._v("Foreword © 2018 by Alice Walker"), _c('br'), _vm._v("Spelman Diary © 1963 the Howard Zinn Revocable Trust"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("Designed by Melissa Bugbee Buchanan"), _c('br'), _vm._v("Set in Minion Pro and Myriad Pro"), _c('br'), _vm._v("Printed and bound by"), _c('br'), _vm._v("The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Most University of Georgia Press titles are available from popular e-book vendors.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("22 21 20 19 18 P 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Names: Zinn, Howard, 1922–2010, author. | Cohen, Robert, 1955 May 21–editor, writer of added commentary. | Walker, Alice, 1944–writer of foreword."), _c('br'), _vm._v("Title: Howard Zinn’s Southern diary : sit-ins, civil rights, and black women’s student activism / Robert Cohen ; foreword by Alice Walker."), _c('br'), _vm._v("Description: Athens : The University of Georgia Press, [2018] | Includes bibliographical references and index."), _c('br'), _vm._v("Identifiers: LCCN 2017059453| ISBN 9780820353227 (hardcover : alk. paper) | ISBN 9780820353289 (pbk. : alk. paper) | ISBN 9780820353234 (ebook)"), _c('br'), _vm._v("Subjects: LCSH: Zinn, Howard, 1922–2010—Diaries. | Spelman College—History. | Southern States—Race relations—History—20th century."), _c('br'), _vm._v("Classification: LCC PS3576.I538 Z46 2018 | DDC 818/.5403 [B]—dc23"), _c('br'), _vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2017059453",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2017059453")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0